import { Card } from "@progress/kendo-react-layout";
import { ListViewItemProps } from "@progress/kendo-react-listview";
import { Fragment, useEffect, useState } from "react";
import DataForm from "../DataForm";
import "./listview.css";

interface CustomListViewProps {
    defaultProps: ListViewItemProps;
    updateData: (result: any) => void;
    deleteData: (prod_num: number) => void;
    idTache: number;
}

export default function CustomListView(props: CustomListViewProps) {
    const [formKey, setFormKey] = useState<number>(0);

    useEffect(() => {
        setFormKey(formKey => formKey + 1);
    }, [props.defaultProps.dataItem.items])

    const getItemCard = (item: any, index: number) => {
        return (
            <Fragment key={index !== -1 ? index : undefined}>
        <Card className="listview-card k-p-sm k-w-full" orientation='vertical' key={index !== -1 ? index : undefined}>
            <DataForm item={item} updateData={props.updateData} deleteData={props.deleteData} formKey={formKey} setFormKey={setFormKey} idTache={props.idTache} />
        </Card>
        </Fragment>
        )
    }

    const getItem = (item: any) => {
        return (
        <div className="k-listview-item listview-item k-ml-0 k-mr-sm k-mb-sm">
            { getItemCard(item, -1)}
        </div>);
    };

    const getGroupedItems = (items: any) => {
        if (items[0].prod_groupe) {
            return (
            <div className="k-listview-item listview-group-container k-ml-0 k-mr-sm k-mb-sm">
                <div className="listview-group-chip">Groupe de variante: {items[0].prod_groupe}</div>
                { items.map((e: any, i: number) => getItemCard(e, i)) }
            </div>);
        } else {
            return (
             <>
                 { items.map((e: any, i: number) => getItem(e)) }
             </>
            );
        }
    };

    return props.defaultProps.dataItem.items.length === 1 ? getItem(props.defaultProps.dataItem.items[0]) : getGroupedItems(props.defaultProps.dataItem.items);
}